import { Shirt, CalendarClock, ShieldAlert } from 'lucide-react';

export const THERME_SITE_TITLE = 'Therme Singapore Groundbreaking';

export const THERME_VENUE_LABEL = 'IMBA Theatre\n18 Marina Gardens Drive';

export const THERME_REGISTRATION_LABEL = 'From 9:15 a.m.';

export const THERME_CEREMONY_LABEL = 'Commences 10:00 a.m.';

export const THERME_MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=IMBA+Theatre,+18+Marina+Gardens+Drive,+Singapore';

export const THERME_MAP_IMAGE =
  'https://res.cloudinary.com/dsb9njrvu/image/upload/q_auto/f_auto/v1781319209/aivoryems/zrsjizubiyxuz1zlpua4.jpg';

export const THERME_MRT_ICON =
  'https://res.cloudinary.com/dsb9njrvu/image/upload/q_auto/f_auto/v1781318004/aivoryems/pozzpt6e4fcpq6pzpvjt.png';

export const THERME_CAR_ICON =
  'https://res.cloudinary.com/dsb9njrvu/image/upload/q_auto/f_auto/v1781318006/aivoryems/o3wgppxho6ucrk2844ef.png';

export const THERME_DIRECTIONS = [
  {
    icon: THERME_MRT_ICON,
    iconWidth: 42,
    iconHeight: 52,
    title: 'By MRT',
    paragraphs: [
      'Please alight at Bayfront MRT Station and take Exit B. Walk through the underground linkway at Marina Bay Sands and walk towards Gardens by the Bay / IMBA Theatre.',
    ],
  },
  {
    icon: THERME_CAR_ICON,
    iconWidth: 52,
    iconHeight: 52,
    title: 'By car',
    paragraphs: [
      'Please park at Bayfront Plaza Car Park. IMBA Theatre is a 5 min walk from Bayfront Plaza Car Park.',
      'Complimentary shuttle service from Bayfront Plaza to IMBA Theatre is also available.',
      'Please note that the complimentary shuttle service will end at 10:00 a.m.',
      'Alternatively, you may choose to park at Marina Bay Sands and take the Overpass Bridge to IMBA Theatre. IMBA Theatre is an 8-minute walk from Marina Bay Sands.',
    ],
  },
];

export const THERME_PROGRAMME = [
  {
    title: 'Opening remarks',
    speaker: 'Mr Mah Bow Tan',
    role: 'Chairman, Therme Group Asia & Therme Group Singapore',
  },
  {
    title: 'Welcome speech',
    speaker: 'Dr Robert Hanea',
    role: 'Founder and Chief Executive Officer, Therme Group',
  },
  {
    title: 'Groundbreaking address',
    speaker: 'Minister Grace Fu',
    role: 'Minister for Sustainability and the Environment\nand Minister-in-charge of Trade Relations',
  },
  {
    title: 'Groundbreaking ceremony',
    speaker: null,
    role: 'Announcement of key partnerships',
  },
];

export const THERME_NOTICES = [
  { icon: Shirt, label: 'Dress code', value: 'Smart Casual' },
  {
    icon: CalendarClock,
    label: 'On the day',
    value: 'Registration from 9:15 a.m. · Ceremony at 10:00 a.m. · Light refreshments before and after',
  },
  { icon: ShieldAlert, label: 'Invitation', value: 'Not transferable' },
];
